import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, Result } from '@softline/core';
import { PalletItem } from '../types/pallet-item';
import {
  SOFTLINE_API_WWS_WARENUEBERNAHME_BEWES_PALETTE_ERLEDIGEN,
  SOFTLINE_API_WWS_WARENUEBERNAHME_BEWES_PALETTE_OEFFNEN,
  SOFTLINE_API_WWS_WARENUEBERNAHME_PALLET_BEWES,
} from '../warenuebernahme.api';

@Injectable()
export class PalletItemRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async load(id: number): Promise<PalletItem[]> {
    const o = await this.#dataAccess.get<Result<PalletItem[]>>({
      path: SOFTLINE_API_WWS_WARENUEBERNAHME_PALLET_BEWES,
      pathParams: { id },
    });

    return o?.result ?? [];
  }

  async complete(item: PalletItem): Promise<PalletItem> {
    const result = await this.#dataAccess.create<PalletItem, Result<PalletItem>>(
      {
        path: SOFTLINE_API_WWS_WARENUEBERNAHME_BEWES_PALETTE_ERLEDIGEN,
      },
      item
    );

    return result?.result;
  }

  async open(item: PalletItem): Promise<PalletItem> {
    const result = await this.#dataAccess.create<PalletItem, Result<PalletItem>>(
      {
        path: SOFTLINE_API_WWS_WARENUEBERNAHME_BEWES_PALETTE_OEFFNEN,
      },
      item
    );

    return result?.result;
  }
}
